"use client";

import { useCryptoComCta } from "./useCryptoComCta";
import { ExchangeIcon } from "@/components/icons";
import { cn } from "@/lib/utils";

type CryptoComCtaRowProps = {
  className?: string;
};

export const CryptoComCtaRow = ({ className }: CryptoComCtaRowProps) => {
  const { isEnabled, rewardAmount, handleClick } = useCryptoComCta();

  if (!isEnabled) return null;

  return (
    <button
      type="button"
      onClick={() => handleClick("main_page")}
      className={cn(
        "w-full rounded-md border border-cede-border-container px-3 py-2 text-left transition-all duration-200",
        "hover:border-cede-primary/30 hover:bg-cede-primary/[0.08] bg-cede-bg-component",
        className,
      )}
    >
      <div className="flex items-center justify-center gap-2 text-sm">
        <ExchangeIcon exchange="cryptocom" size="sm" />
        <span className="font-semibold text-white/85">
          {rewardAmount ? (
            <>
              Sign Up on Crypto.com & Win <span className="font-bold text-cede-primary">${rewardAmount}</span>
            </>
          ) : (
            "Sign Up on Crypto.com"
          )}
        </span>
      </div>
    </button>
  );
};
